import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store";
import userTypes from "@/enums/userTypes";
import teacherRoutes from "@/router/teacherRoutes";
import studentRoutes from "@/router/studentRoutes";
import i18n from "@/plugins/i18n";
import viUniMessage from "@/locale/language/uni-vi.json";
import enUniMessage from "@/locale/language/uni-en.json";

Vue.use(VueRouter);

let backUrl;

const routes = [
    {path: "/", name: "Splash", component: () => import("@/views/splash/SplashScreen")},
    {path: "/signIn", name: "SignIn", component: () => import("@/views/test/SignIn")},
    {
        path: "", component: () => import("@/layout/MainLayout"), children: [
            {path: "/test", name: "Test", component: () => import("@/views/test/TestView")},
        ]
    },

    /* Join Teaching */
    {
        path: "/teaching/join/:id",
        name: "JoinTeaching",
        component: () => import("../views/teacher/teaching/JoinTeaching"),
        meta: {name: i18n.t("Join class")}
    },
]

const router = new VueRouter({
    // mode: "history",
    routes,
})

export const registerRoutes = () => {
    if (!store || !store.getters) {
        backUrl = location.href;
        return false;
    }

    const user = store.getters["auth/user"];
    if (!user) {
        return false;
    }
    const fillRouters = [userTypes.OWNER, userTypes.TEACHER].includes(user?.idType) ? teacherRoutes : studentRoutes;
    fillRouters.filter(r => router.addRoute(r));
    router.addRoute({path: "/:pathMatch(.*)*", name: "PageNotFound", component: () => import("@/views/errors/404")},
    );
}

registerRoutes();


router.beforeEach(async (to, from, next) => {
    const publicPages = ["Splash", "SignIn"];
    if (to.query?.accessToken) {
        await store.dispatch("auth/signInFromAccessToken", {accessToken: to.query.accessToken})
    }
    const user = await store.getters["auth/user"];
    const app = await store.getters["app/website"];
    // const menus = await store.getters["app/menus"];

    if (!publicPages.includes(to.name) && (user == null || app == null)) {
        await store.commit("auth/SET_REDIRECT_URL", to.path);

        next("/");
    } else {
        if (Vue.prototype.$isUniversity()) {
            i18n._vm.messages.vi = {
                ...i18n._vm.messages.vi,
                ...viUniMessage
            }

            i18n._vm.messages.en = {
                ...i18n._vm.messages.en,
                ...enUniMessage
            }
        }
        next();
    }
});

export const getBackUrl = () => {
    const tempUrl = backUrl;
    backUrl = null;
    return tempUrl
}

export default router
